import { defineComponent as _defineComponent } from 'vue'
import type { ListEvidenceLinksQuery } from '~/types/types'

export type GhgSolutionEvidenceLink = NonNullable<
  ListEvidenceLinksQuery['listEvidenceLinks']
>[number]


export default /*#__PURE__*/_defineComponent({
  __name: 'GhgSolutionEvidenceList',
  props: {
    evidenceLinks: null
  },
  setup(__props: any) {



function getEvidenceDisplayName(evidenceLink: GhgSolutionEvidenceLink): string {
  return (
    evidenceLink.evidence?.description
    || evidenceLink.evidence?.filename
    || evidenceLink.evidence?.websiteUrl
    || 'Evidence'
  )
}

function getEvidenceHref(evidenceLink: GhgSolutionEvidenceLink): string {
  return evidenceLink.evidence?.internalUrl || evidenceLink.evidence?.websiteUrl || ''
}

function getEvidencePrimaryLabel(evidenceLink: GhgSolutionEvidenceLink): string {
  return evidenceLink.evidence?.filename || getEvidenceHref(evidenceLink)
}

function getEvidenceSubLink(evidenceLink: GhgSolutionEvidenceLink): string {
  if (!evidenceLink.evidence?.internalUrl) return ''
  return evidenceLink.evidence?.websiteUrl || ''
}

return { __sfc: true,getEvidenceDisplayName, getEvidenceHref, getEvidencePrimaryLabel, getEvidenceSubLink }
}

})